<template>
	<q-table
		:data="data"
		:columns="columns"
		:pagination.sync="server_pagination"
		@request="request"
		:loading="loading"
		:filter="filter"
		row-key="name"
		:no-data-label="$t('no_data_avaliable')"
		:no-results-label="$t('no_results_found')"
		:loading-label="$t('loading_data')"
		:rows-per-page-label="$t('items_per_page')"
		:rows-per-page-options="[5,10,50,100]"
		binary-state-sort
		class="q-mt-xs"
		>

		<template slot="top" slot-scope="props">
			<q-search v-model="filter" icon="far fa-search" :placeholder="$t('search')" :debounce="500" />
		</template>

		<q-tr slot="header" slot-scope="props" :props="props">
			<q-th v-for="col in props.cols" :key="col.name" :props="props">
				{{ $t(col.label) }}
			</q-th>
		</q-tr>

		<q-tr slot="body" slot-scope="props" :props="props">
			<q-td key="full_name" :props="props">
				{{ props.row.full_name }}
			</q-td>

			<q-td key="profile" :props="props">
				{{ translateProfiles(props.row.profile) }}
			</q-td>

			<q-td key="email" :props="props">
				{{ props.row.email }}
			</q-td>

			<q-td key="status" auto-width :props="props"  >
				<q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width">
					{{ $t(getStatus(props.row.status)) }}
				</q-chip>
			</q-td>
		</q-tr>
	</q-table>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	props:['id'],

	data(){
		return{
			data:[],
			filter:'',
			loading: false,
			server_pagination: {
                page: 1,
                rowsNumber: 0,
                rowsPerPage: null,
                descending: false,
                sortBy: null
			},
			 columns: [
                {
                    name: 'full_name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'full_name',
                    sortable: false,
                    show: false
                },
                {
                    name: 'profile',
                    required: true,
                    label: 'profile',
                    align: 'left',
                    field: 'Perfil',
                    sortable: false,
                    show: false
                },
                {
                    name: 'email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'email',
                    sortable: false,
                    show: false
				},
				{
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                    show: false
                },
            ],
		}
	},

	computed:{
		...mapGetters({
			access_token: 'common/access_token',
			num_rows: 'datatable/num_rows',
			profiles: 'registration_lists/profiles'
		}),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
	},

	methods:{
		request({ pagination }){
			this.loading = true
			this.server_pagination = pagination
			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				"page_size": this.server_pagination.rowsPerPage,
				"page": this.server_pagination.page,
				"search": this.filter,
				"ordering": order_by

			}

			this.savePagination()

			this.$axios.get(`/admin_companies/branches/${this.id}/get_branch_users/?` + this.$qs.stringify(data), this.getHeader)
			.then(response => {
				this.server_pagination.rowsNumber = response.data.count
				this.data = []
				this.data = response.data.results.map(user => ({'full_name':user.full_name, 'profile':user.profile, 'email':user.email, 'status':user.status}))
				this.loading = false
			})
			.catch( e => {
				console.log(e)
				this.loading = false
			})
		},

		getStatus(status) {
            if (status == 1) return 'active'
            else if (status == 2) return 'inactive'
            else if (status == 3) return 'deleted'
            else if (status == 4) return 'pre_registered'
            else if (status == 5) return 'active_web_service'
            else if (status == 6) return 'self_registered'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-trash-alt'
            else if (status == 4) return 'fas fa-exclamation-triangle'
            else if (status == 5) return 'fas fa-internet-explorer'
            else if (status == 6) return 'fas fa-portrait'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'warning'
            else if (status == 3) return 'negative'
            else if (status == 4) return 'warning'
            else if (status == 5) return 'positive'
            else if (status == 6) return 'info'
				},

				savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
		},
		
		translateProfiles(value) {
            let profile = value.toUpperCase()
            let term = this.profiles.find(e => e.translations[0].name.toUpperCase() === profile)
            if (term) {
                let translated = term.label.toLowerCase()
                return translated.charAt(0).toUpperCase() + translated.slice(1)
            } else return value
        }
	},

	watch: {
		num_rows: {
            handler: function(newValue) {
                this.loadPagination()
            },
            deep: true
        }
	},

	created(){
		this.loadPagination()

		this.request({pagination: this.server_pagination})
	}
}
</script>

<style>

</style>
